module.exports = __webpack_public_path__ + "img/mclogoV2.7468be95.svg";